<template>
    <div class="px-0">
        <v-container class="px-0 py-5" style="max-width: 100% !important">
            <v-card class="px-0 py-3 size">
                <v-row class="px-5 pt-5 mt-3">
                    <v-col cols="12" align="center" justify="center">
                        <h3 class="headers--text">{{ $t('advanced_fulfillment_prepare.prepare_orders') }} </h3>
                    </v-col>
                </v-row>
                <v-card-text class="px-0">
                    <v-row align="center" justify="center">
                        <v-col cols="10" align="center" justify="center" class="px-0 mx-0">
                            <v-row class="px-0 mx-0" justify="center" align="center">
                                <v-col cols="12" justify="center" align="start" class="px-0 py-1"
                                    style="text-align: start;">
                                    <h4 class="px-0 mx-0 headers--text">
                                        {{ $t('advanced_fulfillment_prepare.orders_will_supply', { count: orders_count }) }}
                                    </h4>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-row align="center" justify="center">
                        <v-col cols="10" align="center" justify="center" class="px-0 mx-0">
                            <v-row class="mb-1 px-0 mx-0" justify="center" align="center">
                                <v-col cols="2" justify="center" align="center" class="px-1 py-1"
                                    style="text-align: left; background-color: var(--v-secondary-base) !important; color: var(--v-white_highlight-base); font-weight: 500;">
                                    {{ $t('advanced_fulfillment_prepare.location') }}
                                </v-col>
                                <v-col cols="10">
                                    <v-row>
                                        <v-col cols="4" justify="start" align="start" class="px-1 py-1"
                                            style="background-color: var(--v-secondary-base) !important; color: var(--v-white_highlight-base); font-weight: 500;">
                                            {{ $t('advanced_fulfillment_prepare.product') }}
                                        </v-col>
                                        <v-col cols="2" justify="start" align="start" class="px-1 py-1"
                                            style="background-color: var(--v-secondary-base) !important; color: var(--v-white_highlight-base); font-weight: 500;">
                                            {{ $t('advanced_fulfillment_prepare.pallet') }}
                                        </v-col>

                                        <v-col cols="2" justify="start" align="start" class="px-1 py-1"
                                            style="background-color: var(--v-secondary-base) !important; color: var(--v-white_highlight-base); font-weight: 500;">
                                            {{ $t('advanced_fulfillment_prepare.batch') }}
                                        </v-col>
                                        <v-col cols="2" justify="start" align="start" class="px-1 py-1"
                                            style="background-color: var(--v-secondary-base) !important; color: var(--v-white_highlight-base); font-weight: 500;">
                                            {{ $t('advanced_fulfillment_prepare.reference') }}
                                        </v-col>
                                        <v-col cols="1" justify="center" align="center" class="px-1 py-1"
                                            style="background-color: var(--v-secondary-base) !important; color: var(--v-white_highlight-base); font-weight: 500;">
                                            {{ $t('advanced_fulfillment_prepare.actions') }}
                                        </v-col>
                                        <v-col cols="1" justify="center" align="center" class="px-1 py-1"
                                            style="background-color: var(--v-secondary-base) !important; color: var(--v-white_highlight-base); font-weight: 500;">
                                            {{ $t('advanced_fulfillment_prepare.supplied') }}
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <span v-for="(location, i) of locations" :key="i">
                        <v-row align="center" justify="center">
                            <v-col cols="10" align="center" justify="center" class="px-0 mx-0">
                                <v-row class="mb-1 px-0 mx-0" justify="center" align="start"
                                    style="font-size: 12px; border-bottom: 2px solid var(--v-horizontal_separator-base);">
                                    <v-col cols="2" justify="start" align="start" class="px-0 py-1"
                                        style="color: var(--v-accent-base); font-weight: 500;">
                                        <v-icon
                                            :class="location.status == 'in_progress' ? '' : 'material-icons-outlined'"
                                            :color="location.status == 'in_progress' ? 'success2' : 'accent'">
                                            fiber_manual_record </v-icon>{{ location.location_name }}
                                    </v-col>

                                    <v-col cols=10>
                                        <v-row v-for="(product, j) of location.products" :key="j">
                                            <v-col cols="4" justify="start" align="start" class="px-1 py-1"
                                                style="color: var(--v-accent-base); font-weight: 500;">
                                                {{ product.product_line }}
                                            </v-col>
                                            <v-col cols="2" justify="start" align="start"
                                                style="color: var(--v-accent-base); font-weight: 500;"
                                                class="px-1 py-1">
                                                {{ product.pallet }}
                                            </v-col>
                                            <v-col cols="2" justify="start" align="start"
                                                style="color: var(--v-accent-base); font-weight: 500;"
                                                class="px-1 py-1">
                                                {{ product.batch }}
                                            </v-col>
                                            <v-col cols="2" justify="start" align="start"
                                                style="color: var(--v-accent-base); font-weight: 500;"
                                                class="px-1 py-1">
                                                {{ product.reference }}
                                            </v-col>
                                            <v-col cols="1" justify="center" align="center"
                                                style="color: var(--v-accent-base); font-weight: 500;"
                                                class="px-1 py-1">
                                                <!-- <v-tooltip top>
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon small @click="changeDetail(product)" color="accent" class="material-icons-outlined" v-on="on">change_circle</v-icon>
                                                    </template>
<span>{{ $t('advanced_fulfillment_prepare.change_picking_location') }}</span>
</v-tooltip> -->
                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon small @click="showProductImage(product)" color="accent"
                                                            class="material-icons-outlined" v-on="on">image</v-icon>
                                                    </template>
                                                    <span>{{ $t('advanced_fulfillment_prepare.see_product_image')
                                                        }}</span>
                                                </v-tooltip>
                                            </v-col>
                                            <v-col v-if="(product.scanned != product.required)" cols="1"
                                                justify="center" align="center" color="accent" style=" font-weight: 500"
                                                class="px-1 py-1">
                                                {{ product.scanned }} / {{ product.required }}
                                            </v-col>

                                            <v-col v-else-if="(product.scanned == product.required)" cols="1"
                                                justify="center" align="center" style="font-weight: 500"
                                                class="px-1 py-1 success2--text">
                                                {{ product.scanned }} / {{ product.required }}
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </span>
                    <br>
                    <br>
                    <v-row class="px-5 py-0" justify="center" align="center">
                        <v-col class="px-0 mx-0" cols="10" justify="end" align="end">
                            <v-row justify="end" align="end">
                                <v-btn class="mx-3" outlined color="secondary" @click="show_modal_cancel = true">
                                    {{ $t('advanced_fulfillment_prepare.cancel') }}
                                </v-btn>
                                <v-btn class="right white_highlight--text" :disabled="!all_scanned" color="secondary"
                                    @click="save">
                                    {{ $t('advanced_fulfillment_prepare.save') }}
                                </v-btn>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-container>

        <v-dialog v-model="show_product_image" persistent max-width="90%">
            <v-card>
                <v-card-title class="justify-center">
                    <v-row align="center" justify="center">
                        <h3 class="text-uppercase">
                            <!-- {{ $t('advanced_fulfillment_prepare.product_image') }} -->
                            {{ showed_sku }}
                        </h3>
                    </v-row>
                    <v-btn class="right tools-view-height mx-1" outlined color="error"
                        style="max-width: 30px !important; min-width: 30px !important"
                        @click="show_product_image = false; this.showed_img = ''">
                        <v-icon class="px-1" small>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="mt-4">
                    <v-img :src="this.showed_img" style="max-height: 700px; max-width: 700px;"></v-img>
                </v-card-text>
                <div class="marker1"></div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="show_modal_cancel" persistent max-width="90%">
            <v-card>
                <v-card-title class="justify-center">
                    <v-row align="center" justify="center" class="mt-2">
                        <h3 class="text-uppercase">
                            {{ $t('advanced_fulfillment_prepare.cancel_modal') }}
                        </h3>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-row align="center" justify="center" class="py-3 my-3 text-center">
                        <v-col cols="12">
                            <h5>{{ $t('advanced_fulfillment_prepare.cancel_process') }}</h5>
                        </v-col>
                    </v-row>

                    <div class="d-flex">
                        <v-spacer></v-spacer>
                        <v-btn class="mx-3" text @click="show_modal_cancel = false">{{
                            $t('advanced_fulfillment_prepare.no')
                            }}</v-btn>
                        <v-btn color="error" @click="cancel()">
                            {{ $t('advanced_fulfillment_prepare.yes') }}
                        </v-btn>
                    </div>
                </v-card-text>
                <div class="marker"></div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="modalAlreadyOpen" persistent max-width="50%">
            <v-card>
                <v-row align="center" justify="center" class="text-center py-8 px-10">
                    <v-col cols="12">
                        <h3>{{ $t('fulfillments_cod_pendings.multiple_fulfillment_tabs') }}</h3>
                    </v-col>
                </v-row>
                <div class="marker"></div>
            </v-card>
        </v-dialog>
        
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color"
            style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>

import { HttpExternalShipmentRepository } from '../../infrastructure/external_shipment_repository';
import { HttpProductRepository } from '../../../products/infrastructure/product_repository';
import { HttpShipmentsInProcessRepository } from '../../../shipment_in_process/infrastructure/repositories/shipment_in_process_repository';
import { affExternalShipmentsPrepareUseCase } from '../../application/use_cases/aff_external_shipments_prepare_use_case';
import { affExternalShipmentsScanUseCase } from '../../application/use_cases/aff_external_shipments_scan_use_case';
import { affExternalShipmentsGetCurrentSessionUseCase } from '../../application/use_cases/aff_external_shipments_get_current_session_use_case';
import { productGetImageUseCase } from '../../../products/application/dtos/product_get_image_use_case';
import { releaseExternalShipmentsInProcessUseCase } from '../../../shipment_in_process/application/use_cases/release_external_shipments_in_process_use_case';

export default {
    computed: {
    },
    data() {
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            barcode: "",
            locations: [],
            alert_modal: false,
            can_update_detail: false,
            show_modal_cancel: false,
            modalAlreadyOpen: false,
            product_to_update: {
                text: "",
                location: "",
                barcode: "",
                batch: "",
                box: "",
                location_barcode: "",
                reference: "",
                pallet: "",
                detail: ""
            },
            all_scanned: false,
            show_product_image: false,
            showed_img: "",
            showed_sku: "",
            transaction_id: '',
            orders_count: 0
        }
    },
    async mounted() {
        this.$store.state.module = "headers.advanced_fulfillment_eon_prepare";
        await this.checkIfCanOpen(this.shipping_service);        

        window.addEventListener('beforeunload', this.leaveHandler);
        window.addEventListener('keypress', this.keyPressHandler, { capture: true });

        this.index();
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.leaveHandler);
        window.removeEventListener('keypress', this.keyPressHandler);
    },
    methods: {
        async leaveHandler() {
            const t_id = localStorage.getItem('trace_id');

            if (!t_id) {
                event.preventDefault();
                event.returnValue = '';
                return;
            }
        },
        async keyPressHandler(e) {
            if (this.last == true && /^\S+$/.test(e.key)) {
                this.barcode = e.key;
                this.last = false;
            }
            else if (e.code == "Enter") {
                this.last = true;
                this.scanIdentifier();
            }
            else if (/^\S+$/.test(e.key)) this.barcode += e.key;
        },
        async index() {
            this.locations = [];

            try {
                var t_id = localStorage.getItem('trace_id');
                var ord = JSON.parse(localStorage.getItem('afpendings'))

                if (ord?.length == 0 || ord == null || ord == undefined) return;
                this.orders_count = ord.length;

                if ((t_id == null || t_id == undefined) && (ord != null && ord != undefined)) {
                    const response = await affExternalShipmentsPrepareUseCase(ord, HttpExternalShipmentRepository);
                    localStorage.setItem('trace_id', response.data.transaction_id);
                    this.transaction_id = response.data.transaction_id;

                    this.locations = response.data.locations;
                }
                else if ((t_id != null && t_id != undefined)) {
                    const resp = await affExternalShipmentsGetCurrentSessionUseCase(t_id, HttpExternalShipmentRepository);

                    this.transaction_id = resp.data.transaction_id;

                    this.locations = resp.data.locations;

                    this.locations.forEach(x => {
                        if (x.location_id == parseInt(resp.data.active_location)) x.status = "in_progress";
                        else if (x.status != "completed") x.status = "pending";
                    });
                }
            }
            catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null ? e : e.response.data.fault.message
                }
            }
        },
        methodHandler(object) {
            this[object.methodName](object.parameters)
        },
        save() {
            localStorage.removeItem('afpendings');
            localStorage.removeItem('trace_id');
            this.$router.go(-1);
        },
        closeModal() {
            this.alert_modal = false;
        },
        async scanIdentifier() {
            try {
                const response = await affExternalShipmentsScanUseCase(this.transaction_id, this.barcode, HttpExternalShipmentRepository);

                await this.updateList(response.data);
            }
            catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null ? e : e.response.data.fault.message
                }
            }
        },
        async updateList(data) {
            if (data.type == "product") {
                this.locations.some(x => {
                    const p_bff = x.products.find(y => y.detailed_stock_id == data.detailed_stock_id);

                    if (p_bff != undefined) {
                        p_bff.scanned = data.scanned;

                        if (data.session_completed) this.all_scanned = true;
                        if (data.location_completed) x.status = "completed"

                        return true;
                    }

                    return false;
                })
            }
            else if (data.type == "location") {
                this.locations.forEach(x => {
                    if (x.location_id == data.location_id) x.status = data.status;
                    else if (x.status != "completed") x.status = "pending";
                })
            }
        },
        async cancel() {            
            this.show_modal_cancel = false;

            try {
                const response = await releaseExternalShipmentsInProcessUseCase(HttpShipmentsInProcessRepository,this.transaction_id);
                response
                localStorage.removeItem('afpendings');
                localStorage.removeItem('trace_id');

                this.$router.go(-1);
            }
            catch(e) {
                this.$router.go(-1);

                console.log(e);
            }
        },
        async showProductImage(product) {
            try {
                const response = await productGetImageUseCase(product.product_id, HttpProductRepository);

                this.show_product_image = true;
                this.showed_img = response.data.success.arguments[0].image;
                this.showed_sku = product.sku;
            }
            catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response?.data?.fault?.message ?? e
                }
            }
        },
        async checkIfCanOpen(){
            localStorage.open_pages = Date.now();
            window.addEventListener('storage', (e) => {
                if(e.key == "open_pages") localStorage.setItem("a_fulfillment_eon", Date.now())
                if(e.key == "a_fulfillment_eon") this.modalAlreadyOpen = true;              
            }, false);
        },
    },
    watch: {}
}
</script>

<style lang="css"></style>